import { Layout } from "@/components/Layout";
import { VapiSync } from "@/components/VapiSync";
import { VapiCopilot } from "@/components/VapiCopilot";

export default function WebhookGuide() {
  return (
    <Layout>
      <div className="max-w-3xl w-full mx-auto px-6 py-12 animate-fade-up">
        <p className="text-xs uppercase tracking-[0.2em] font-bold text-muted-foreground mb-2">Integration</p>
        <h1 className="font-heading text-3xl sm:text-4xl font-black tracking-tighter mb-8">Voice agent</h1>

        <VapiSync />

        <VapiCopilot />
      </div>
    </Layout>
  );
}
